import { feRequestDepositValue, feSetDepositReader, feSetDepositSource, feSidebarClose, feSidebarOpen, feTakeDepositInput } from 'actions/ui.actions';
import fromAnyToString from 'utils/converters/fromAnyToString';
import alwaysSame from 'utils/functions/nullary/alwaysSame.util';
import logger from 'utils/logger.util';

const L = logger('appointmentDepositReducer'); // eslint-disable-line no-unused-vars

const reduceClose = () => ({ requestValue: null, takeInput: null, source: null, selectedReader: null });
const reduceOpen = () => ({ requestValue: 0, takeInput: '', source: null, selectedReader: null });

const reduceRequestDepositValue = (state, action) => ({ ...state, requestValue: fromAnyToString(action.data) });
const reduceTakeDepositInput = (state, action) => ({ ...state, takeInput: fromAnyToString(action.data) });
const reduceSetDepositSource = (state, action) => ({ ...state, source: fromAnyToString(action.data) });
const reduceSetDepositReader = (state, action) => ({ ...state, selectedReader: action.data ?? null });

const MAP = Object.freeze({
  [feSidebarOpen.AT.name]: reduceOpen,
  [feSidebarClose.AT.name]: reduceClose,

  [feRequestDepositValue.AT.name]: reduceRequestDepositValue,
  [feTakeDepositInput.AT.name]: reduceTakeDepositInput,
  [feSetDepositSource.AT.name]: reduceSetDepositSource,
  [feSetDepositReader.AT.name]: reduceSetDepositReader,
});

const appointmentDepositReducer = (state, action) => (MAP[action?.type] ?? alwaysSame)(state ?? {}, action ?? {});

// noinspection JSUnusedGlobalSymbols
export default appointmentDepositReducer;
